// save ไว้ที่ D:\vuejs\project\tai_book\src\store\api\services\CustomersService.js
import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
    // users Service ------------------------------------
    usersList(credentials) {
        // console.log('credentials' + credentials)
        var param = '&pageno=' + credentials.pageNo
        param += '&rowperpage=' + credentials.rowsPerPage
        if (credentials.sortBy) {
            param += '&sort=' + credentials.sortBy
            if (credentials.descending === 'true') {
                param += ' desc'
            }
        }
        return Api.httpServer().post('customers/default.asp?controller=users&action=list' + param, credentials)
    },
    usersItemByID(credentials) {
        // console.log('credentials', credentials)
        // var param = '&id=' + credentials.id
        // console.log('param', param)
        return Api.httpServer().post('customers/default.asp?controller=users&action=listbyparam', credentials)
    },
    usersListByParam(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=users&action=listbyparam', credentials)
    },
    usersInsert(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=users&action=insert', credentials)
    },
    usersUpdate(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=users&action=update', credentials)
    },
    usersDelete(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=users&action=delete', credentials)
    },
    usersChangePass(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=users&action=changepass', credentials)
    },
    signin(data) {
        return Api.httpServer()
            .post('api/customerAuthen.asp', data)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error))
    },
    register(data) {
        return Api.httpServer()
            .post('api/customerRegister.asp', data)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error))
    },
    forgot(data) {
        return Api.httpServer()
            .post('api/customerForgotPassword.asp', data)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error))
    },
    // testingReq Service ------------------------------------
    testingReqList(credentials) {
        // console.log('credentials' + credentials)
        var param = '&pageno=' + credentials.pageNo
        param += '&rowperpage=' + credentials.rowsPerPage
        param += '&search=' + encodeURIComponent(credentials.search)
        if (credentials.sortBy) {
            param += '&sort=' + credentials.sortBy
            if (credentials.descending === 'true') {
                param += ' desc'
            }
        }
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=list' + param, credentials)
    },
    testingReqItemByID(credentials) {
        // console.log('credentials', credentials)
        // var param = '&id=' + credentials.id
        // console.log('param', param)
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=listbyid', credentials)
    },
    testingReqListByParam(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=listbyparam', credentials)
    },
    ContactList(credentials) {
        var param = '&pageno=' + credentials.pageNo
        param += '&rowperpage=' + credentials.rowsPerPage
        param += '&search=' + encodeURIComponent(credentials.search)
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=ContactList' + param, credentials)
    },
    AddressList(credentials) {
        var param = '&pageno=' + credentials.pageNo
        param += '&rowperpage=' + credentials.rowsPerPage
        param += '&search=' + encodeURIComponent(credentials.search)
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=AddressList' + param, credentials)
    },
    testingReqInsertFZ(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=insertFZ', credentials)
    },
    testingReqInsert(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=insert', credentials)
    },
    testingReqUpdate(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=update', credentials)
    },
    testingReqDelete(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=testingReq&action=delete', credentials)
    },
    //freezone
    vw_requestItemByID(credentials) {
        // console.log('credentials', credentials)
        // var param = '&id=' + credentials.id
        // console.log('param', param)
        return Api.httpServer().post('freezone2022/default.asp?controller=vw_request&action=listbyparam', credentials)
    },
    vw_requestListByParam(credentials) {
        return Api.httpServer().post('freezone2022/default.asp?controller=vw_request&action=listbyparam', credentials)
    },
    vw_requestInsert(credentials) {
        return Api.httpServer().post('freezone2022/default.asp?controller=vw_request&action=insert', credentials)
    },
    vw_requestUpdate(credentials) {
        return Api.httpServer().post('freezone2022/default.asp?controller=vw_request&action=update', credentials)
    },
    vw_requestDelete(credentials) {
        return Api.httpServer().post('freezone2022/default.asp?controller=vw_request&action=delete', credentials)
    },
    // sample Service ------------------------------------
    sampleList(credentials) {
        // console.log('credentials' + credentials)
        var param = '&pageno=' + credentials.pageNo
        param += '&rowperpage=' + credentials.rowsPerPage
        param += '&search=' + encodeURIComponent(credentials.search)
        if (credentials.sortBy) {
            param += '&sort=' + credentials.sortBy
            if (credentials.descending === 'true') {
                param += ' desc'
            }
        }
        return Api.httpServer().post('customers/default.asp?controller=sample&action=list' + param, credentials)
    },
    sampleItemByID(credentials) {
        // console.log('credentials', credentials)
        // var param = '&id=' + credentials.id
        // console.log('param', param)
        return Api.httpServer().post('customers/default.asp?controller=sample&action=ListByID', credentials)
    },
    sampleListByParam(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=sample&action=listbyparam', credentials)
    },
    sampleListByParamFZ(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=sample&action=listbyparamFZ', credentials)
    },
    sampleInsert(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=sample&action=insert', credentials)
    },
    sampleUpdate(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=sample&action=update', credentials)
    },
    sampleDelete(credentials) {
        return Api.httpServer().post('customers/default.asp?controller=sample&action=delete', credentials)
    },
    //<services>
    errorHandel(res) {
        if (res.status === 401) {
            store.state.users.main = {}
            router.push('/signin')
        }
    }
}